import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import api from "../../api";
import ButtonLoader from "components/Common/ButtonLoader";
import { Link, useHistory, useParams } from "react-router-dom";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";
import { decryptDataFromArray, encryptDataToArray } from "helpers/EncDec";
import { Trans, useTranslation } from "react-i18next";

const styles = {
  option: (styles, state) => ({
    ...styles,
    backgroundColor: state.isSelected ? "#E27235" : "",
  }),
};

const EditVacancyType = props => {
  const { t } = useTranslation();
  const history = useHistory();
  let { vacancyId } = useParams();
  let selectRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [statePayload, setStatePayload] = useState({});

  const [lang_id, setLangId] = useState(() => {
    // Retrieve the lang_id from localStorage or set it to "1" if it doesn't exist or equals 1
    const storedLangId = localStorage.getItem("lang_id");
    return storedLangId && storedLangId !== "1" ? storedLangId : "1";
  });

  const handleInput = event => {
    const { name, value } = event.target;

    setStatePayload(prevState => ({
      ...prevState,
      [name]: value,
    }));
    setErrors(prevState => ({
      ...prevState,
      [name]: "",
    }));
  };

  const updateVacancy = payload => {
    api
      .patch(
        `${process.env.REACT_APP_API_URL}/admin/vacancyType/update-vacancyType/${vacancyId}`,
        payload
      )
      .then(response => {
        setIsLoading(false);
        history.push("/vacancyType-list");
      })
      .catch(err => {
        setIsLoading(false);
      });
  };

  const validateForm = () => {
    let isValid = true;
    let error = {};
    if (!statePayload?.title?.trim()) {
      error = {
        ...error,
        title: "t(`vacancy_type.ValidationMsg`)",
      };
      isValid = false;
    }
    if (!statePayload?.description?.trim()) {
      error = {
        ...error,
        description: "t(`vacancy_type.ValidationMsg`)",
      };
      isValid = false;
    }
    if (!statePayload?.status) {
      error = {
        ...error,
        status: "t(`vacancy_type.ValidationMsg`)",
      };
      isValid = false;
    }
    if (!statePayload?.sequence) {
      error = {
        ...error,
        sequence: "t(`vacancy_type.ValidationMsg`)",
      };
      isValid = false;
    }
    setErrors(error);
    return isValid;
  };

  const handleSubmit = event => {
    event.preventDefault();
    setErrors({});
    setIsLoading(true);

    const isValid = validateForm();

    if (!isValid) {
      setIsLoading(false);
      return false;
    }

    // setting payload to save inside the database;
    let payload = new FormData();
    payload.append("title", statePayload?.title?.trim());
    payload.append("description", statePayload?.description?.trim());
    payload.append("status", statePayload?.status);
    payload.append("sequence", statePayload?.sequence);

    payload = Object.fromEntries(payload);

    payload = encryptDataToArray(payload);

    updateVacancy({
      query: payload,
    });
  };

  const fetchVacancyDetails = lang_id => {
    // console.log('user',userId);
    api
      .get(
        `${process.env.REACT_APP_API_URL}/admin/vacancyType/fetch-VacanceById/${vacancyId}`
      )
      .then(response => {
        let responseData = decryptDataFromArray(response?.data);

        const { success, allVacType } = responseData;
        if (success) {
          setStatePayload({
            ...allVacType,
            sequence: `${allVacType?.sequence}`,
            status: `${allVacType?.status}`,
          });
        }
      })
      .catch(err => console.log("Error:::", err));
  };

  useEffect(() => {
    fetchVacancyDetails(lang_id);

    return () => {};
  }, []);

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  return (
    <div className="page-content">
      <Container fluid>
        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center">
            <Col lg="6" md="6">
              <Link to="/vacancyType-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  {t(`vacancy_type.EditVacancyType`)}
                </h5>
              </Link>
            </Col>

            {/* <Col lg="6" md="6">
              <div class="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
                <Link to="/vacancyType-list" className="btn btn-primary">
                  Back To Listing
                </Link>
              </div>
            </Col> */}
          </Row>
        </div>
        {/* <h2 className="heading-two">Vacancy Details:</h2>
        <p>Please fill in your vacancy details below</p> */}

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section">
            <Row>
              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {t(`vacancy_type.VacancyTypeName`)}*
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`vacancy_type.VacancyTypeName`)}
                  name="title"
                  value={statePayload?.title}
                  onChange={handleInput}
                  title={`Please enter ${t(`vacancy_type.VacancyTypeName`)}`}
                />
                {errors?.title && (
                  <small className="text-danger"> {errors?.title} </small>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {" "}
                  {t(`vacancy_type.Description`)}*
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t(`vacancy_type.Description`)}
                  name="description"
                  value={statePayload?.description}
                  onChange={handleInput}
                  title={`Please enter ${t(`vacancy_type.Description`)}`}
                />
                {errors?.description && (
                  <small className="text-danger"> {errors?.description} </small>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {" "}
                  {t(`vacancy_type.SelectStatus`)}*
                </Form.Label>
                <select
                  type="select"
                  name="status"
                  className="col-md-6 mb-1 form-control form-select"
                  style={{ width: "100%" }}
                  onChange={handleInput}
                  title={`Please enter ${t(`vacancy_type.SelectStatus`)}`}
                >
                  <option value="">{t(`vacancy_type.SelectStatus`)}</option>
                  <option value="1" selected={statePayload?.status == "1"}>
                    {t(`vacancy_type.Active`)}
                  </option>
                  <option value="0" selected={statePayload?.status == "0"}>
                    {t(`vacancy_type.Inactive`)}
                  </option>
                </select>
                {errors?.status && (
                  <small className="text-danger"> {errors?.status} </small>
                )}
              </Form.Group>

              <Form.Group className="col-lg-4 col-md-6 mb-3 floating-label">
                <Form.Label className="float-label">
                  {" "}
                  {t(`vacancy_type.Sequence`)}*
                </Form.Label>
                <select
                  type="select"
                  name="sequence"
                  className="col-md-6 mb-1 form-control 
                form-select"
                  style={{ width: "100%" }}
                  onChange={handleInput}
                  title={`Please enter ${t(`vacancy_type.Sequence`)}`}
                >
                  {[...Array(15)].map((_, index) => (
                    <option
                      key={index + 1}
                      value={index + 1}
                      selected={statePayload?.sequence == index + 1}
                    >
                      {index + 1}
                    </option>
                  ))}
                </select>
                {errors?.sequence && (
                  <small className="text-danger"> {errors?.sequence} </small>
                )}
              </Form.Group>
            </Row>

            <Form.Group className="cta text-center d-flex justify-content-start mt-4 gap-3 pb-3">
              <Link to="/vacancyType-list" className="btn btn-secondary">
                {t(`vacancy_type.Cancel`)}
              </Link>
              <ButtonLoader
                title={t(`vacancy_type.SaveDetails`)}
                variant="primary"
                type="submit"
                loading={isLoading}
                message={"Saving"}
                onClick={e => {
                  handleSubmit(e);
                }}
              />
            </Form.Group>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default EditVacancyType;
